export enum ReviewCategoryType {
    Food = 'Food',
    Delivery = 'Delivery',
}